"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubitemsFieldLogic = void 0;
var subitems_fieldtype_1 = require("./subitems.fieldtype");
Object.defineProperty(exports, "SubitemsFieldLogic", { enumerable: true, get: function () { return subitems_fieldtype_1.SubitemsFieldLogic; } });
